import { createAsyncThunk } from "@reduxjs/toolkit";

import { isErrorResult, makeApiRequest, ENDPOINTS_PROOF } from "services";

import { ErrorResult } from "services/types";
import { CheckArbitrumProofPayload } from "./types";
import { TokenProofResponse } from "../solana-proof/types";

export const checkArbitrumProof = createAsyncThunk<
  TokenProofResponse,
  CheckArbitrumProofPayload,
  { rejectValue: ErrorResult }
>("zkp/check-arbitrum-proof", async (data, { rejectWithValue }) => {
  const result = await makeApiRequest<TokenProofResponse>({
    method: "POST",
    url: ENDPOINTS_PROOF.checkArbitrumProof,
    data,
  });

  if (isErrorResult(result)) {
    return rejectWithValue(result);
  }

  return result;
});
